// Развертывание блока "Преимущества" на мобильном
itsoftApp.createModule("advantagesSeeMore", function() {

    $(".advantages__see-more").click(function() {
        $(this).hide(300);
        var i = 2,
            j = 0;
        $(".advantages__box").each(function() {
            if (j > i) {
                $(this).slideDown(300);
            }
            j++;
        });
    });

});
